import { Pagination, PaginationResponse } from './Pagination';

export const hasPaginationChanged = (
  pagination: PaginationResponse | undefined,
  paginationData: Pagination
) =>
  pagination &&
  (pagination.items !== paginationData.itemPerPage ||
    pagination.page !== paginationData.currentPage ||
    pagination.totalItems !== paginationData.totalItems ||
    pagination.totalPages !== paginationData.totalPages);

export const mapPaginationToPaginationData = (
  pagination: PaginationResponse
) => ({
  customItemPerPage: pagination.items,
  itemPerPage: pagination.items,
  currentPage: pagination.page,
  totalItems: pagination.totalItems,
  totalPages: pagination.totalPages,
});
